import React, { useState } from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components/macro';
import { Helmet } from 'react-helmet';

import useMedia from 'hooks/useMedia';
import ScrollTopOnMount from 'components/utility/ScrollTopOnMount/ScrollTopOnMount';
import NotificationSettingsModal from '../../components/notifications/Settings';
import ChartsHeader from 'components/Header/ChartsHeader/ChartsHeader';
import BackToTop from 'components/BackToTop/BackToTop';
import Charts from 'components/Charts/Charts';
import { ChartTypes } from 'types/shared';
import { useTopicFilters } from '../../components/TopicFilters/utils/useTopicFilters';
import Footer from 'components/Footer/Footer';

const Content = styled('div')`
  margin: ${({ theme }): string =>
    `4.125em ${theme.spacing.small} ${theme.spacing.small}`};

  @media screen and (min-width: 60em) {
    margin: 3.56rem;
  }
`;

const Main = styled.div.attrs({
  role: 'main',
})`
  position: relative;
  z-index: 1;
  flex: auto;
  display: flex;
  flex-flow: column nowrap;
  background-color: ${({ theme }): string => theme.LightGrey};
`;

interface IChartProps {
  chartType: ChartTypes;
}

export interface IChartInfoProps {
  entityTitle: string;
  chartTitle: string;
  countryName: string;
}

const Chart: React.FC<RouteComponentProps<IChartProps>> = (props) => {
  const isLargeScreen = useMedia('(min-width: 60em)');
  const [chartInfo, setChartInfo] = useState<IChartInfoProps>();
  const [filters] = useTopicFilters();

  return (
    <>
      <ScrollTopOnMount />
      <Helmet defer={false} title="Chart" />

      <NotificationSettingsModal />

      <ChartsHeader
        topicEntityType={
          props.match.params.chartType === 'official'
            ? 'Official Charts'
            : 'DSP Charts'
        }
        chartInfo={chartInfo}
      />

      <Main>
        <Content>
          <Switch>
            <Route
              path={`/chart/dsp`}
              render={(renderProps): JSX.Element => (
                <Charts
                  {...renderProps}
                  key="dsp-component"
                  chartPage="dsp"
                  isLargeScreen={isLargeScreen}
                  setChartInfo={setChartInfo}
                  defaultCountry={filters?.country}
                />
              )}
            />
            <Route
              path={`/chart/official`}
              render={(renderProps): JSX.Element => (
                <Charts
                  {...renderProps}
                  key="official-component"
                  chartPage="official"
                  isLargeScreen={isLargeScreen}
                  setChartInfo={setChartInfo}
                />
              )}
            />
          </Switch>
        </Content>
      </Main>
      <BackToTop />
      <Footer />
    </>
  );
};

export default Chart;
